import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import CustomQuerySetupPrebuiltItemComponent from 'webapp/components/custom-query/setup/prebuilt/item';
import FormRadiobuttonGroupComponent from 'webapp/components/form/radiobutton-group';

import type CustomMetricSetupFormItemField from 'webapp/models-custom/custom-metric-setup-form/item/field';
import type CustomMetricSetupFormItemGroupCloneable from 'webapp/models-custom/custom-metric-setup-form/item/group/cloneable';
import type CustomMetricSetupFormPrebuilt from 'webapp/models-custom/custom-metric-setup-form/prebuilt';

interface Args {
	form: CustomMetricSetupFormPrebuilt;
	group: CustomMetricSetupFormItemGroupCloneable;
	model: CustomMetricSetupFormItemField[];
	index: number;
	canAdd: boolean;
	isDisabled: boolean;
	onContentChange: () => void;
}

export default class CustomQuerySetupPrebuiltFormCloneableRowComponent extends Component<Args> {
	@tracked isOpen = false;

	get isFirst(): boolean {
		return this.args.index === 0;
	}

	get hasSwitcher(): boolean {
		return this.args.index === 1;
	}

	get hasOperator(): boolean {
		return this.args.index > 1;
	}

	get isLast(): boolean {
		return this.args.index + 1 === this.args.group.shownItems.length;
	}

	get hasLineDown(): boolean {
		return !this.isLast || this.args.canAdd;
	}

	get isSwitcherDisabled(): boolean {
		return this.args.isDisabled || this.args.group.isOperatorPreset;
	}

	@action
	changeGroupOperator(operator: AnySimpleValue): void {
		this.args.group.operator = operator as string;
	}

	@action
	removeCloneable(): void {
		if (this.args.isDisabled) {
			return;
		}
		this.args.group.removeShownItem(this.args.index);
		this.args.onContentChange();
	}
	<template>
		<div class="cloneable {{if this.hasLineDown 'lineDown'}}">
			{{#each @model as |item|}}
				<CustomQuerySetupPrebuiltItemComponent
					@form={{@form}}
					@model={{item}}
					@groupItems={{@model}}
					@onContentChange={{@onContentChange}}
					@isDisabled={{@isDisabled}}
				/>
			{{/each}}

			<a
				role="button"
				class="rem {{if @isDisabled 'disabled'}}"
				{{on "click" this.removeCloneable}}
			><CommonUiIconComponent @name="Close" @size="sm" />
			</a>

			{{#if this.hasSwitcher}}
				<span class="operator switcher {{if this.isSwitcherDisabled 'disabled'}}">
					<FormRadiobuttonGroupComponent
						class="radiobutton-switcher"
						@name="group-operator"
						@selected={{@group.operator}}
						@options={{@group.possibleOperators}}
						@isDisabled={{this.isSwitcherDisabled}}
						@onChange={{this.changeGroupOperator}}
						@theme="dark"
					/>
				</span>
			{{else if this.hasOperator}}
				<span class="operator text">{{@group.operator}}</span>
			{{/if}}
		</div>
	</template>
}
